// extracted by mini-css-extract-plugin
export default {"global-alert__alert":"aeTZqJFZDyvWy4p1LcNr","global-alert__alert--visible":"KnR5UX7parefA89L225q","global-alert":"xib_NWkIU4UU1YEogAUQ","alert":"G2GXXki46pFj9hQ0ZA8J"};